import { EntitlementsProject } from '../projectEntitlementTypes';

const TEMPLATE_CLASSIFICATION = 'template';

export default (project: EntitlementsProject) =>
  project.classification === TEMPLATE_CLASSIFICATION;
